import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/elite-feats-cms/components/badgeStyle";

const useStyles = makeStyles(styles);

interface BadgeProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "color"> {
  color?: "primary" | "warning" | "danger" | "success" | "info" | "rose" | "gray" | "tools1" | "tools2" | "tools3" | "tools4" | "tools5";
  children?: React.ReactNode;
}

export default function Badge(props: BadgeProps): React.ReactElement {
  const { color, children } = props;
  const classes = useStyles();
  return (
    <span className={classes.badge + " " + classes[color as string]}>
      {children}
    </span>
  );
}

